import { z } from 'zod';
// Google paid strategy proposal (autopilot phase A6). Sibling of
// MetaPaidStrategyOutput but shaped for Google Search Ads —
// RSA-style angles (headlines + descriptions + keyword themes)
// instead of social-feed-style hook + audience.
//
// Google's targeting knobs are mostly keyword + match-type +
// audience signals; format isn't a thing (it's all RSAs). So
// each angle is the search intent it targets + sample headlines/
// descriptions to test + the keyword themes to bid on.
//
// Founder-triggered ("what should I test next?" on a creative_ads
// campaign). Sonnet — strategic read. ~$0.10-0.15/run.
export const googlePaidStrategyAngleSchema = z.object({
    /** What kind of query this angle targets, in mag's voice.
     *  ("comparison queries like 'X vs Y'", "'how to fix X'
     *  problem-aware searches", "branded competitor queries").
     *  One sentence. */
    searchIntent: z.string().min(1).max(200),
    /** 3-5 candidate headlines for the RSA. Each ≤30 chars
     *  (Google's actual headline cap). Lowercase, mag voice.
     *  When run, the RSA will rotate these — these are seeds, not
     *  the final selection. */
    headlines: z.array(z.string().min(1).max(30)).min(3).max(5),
    /** 1-2 candidate descriptions. Each ≤90 chars (Google's
     *  description cap). */
    descriptions: z.array(z.string().min(1).max(90)).min(1).max(2),
    /** 2-4 keyword themes to bid on. Each is a short phrase + an
     *  inline match-type hint ("[broad] productivity tools for
     *  founders" / "[exact] magig pricing"). */
    keywordThemes: z.array(z.string().min(1).max(120)).min(2).max(4),
    /** Suggested daily budget USD. Testing budget — $5-50.
     *  Founder bumps after metric review. */
    suggestedDailyBudget: z.number().int().min(5).max(50),
    /** Why this angle. Cites actual signal from the campaign's
     *  metric history or brand brain. ≤500 chars, lowercase. */
    rationale: z.string().min(1).max(500),
});
export const googlePaidStrategyOutputSchema = z.object({
    /** Mag's one-sentence framing of the strategy. ("your conversion
     *  rate on the 'how to' query cohort is 3× the brand-term cohort
     *  — i'd lean problem-aware next.") */
    summary: z.string().min(1).max(280),
    /** 3-5 angles to test. Fewer is sharper. */
    angles: z.array(googlePaidStrategyAngleSchema).min(1).max(6),
    /** ISO timestamp the strategy was generated. */
    generatedAt: z.string(),
    /** Cost USD for transparency. */
    costUsd: z.number().min(0),
});
//# sourceMappingURL=google-paid-strategy.js.map